import { Spin } from "antd";
import { FC } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./Loader.module.scss";

interface LoaderProps {
  isMain?: boolean;
  dataTestId?: string;
}

export const Loader: FC<LoaderProps> = ({ isMain = true, dataTestId }) => {
  return (
    <div
      data-testid={dataTestId}
      className={styles.loaderMain}
      style={{
        width: !isMain && "100%",
        height: !isMain && "100%",
        zIndex: !isMain && 11,
      }}
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 64 }} spin />} />
    </div>
  );
};
